<template>
  <div>
    <county-header
      id="county-header"
      :countyName="county.name"
      :countySlug="county.slug"
      :resultsPresent="true"
    />
    <div
      class="container g-0"
      :class="isMobile === 'mobile' ? 'mt-0' : 'my-4'"
      id="home"
    >
      <toolbar
        v-if="!error"
        :county="county"
        :isFuture="isFuture"
        :item="parcel"
        :loading="loading"
        :error="error !== null"
        :class="isMobile"
        :anyAlertsExist="anyAlertsExist"
        :isMobile="isMobile"
      />
      <alerts-component
        v-if="
          !error &&
            !loading &&
            parcel.systemParameters &&
            parcel.systemParameters[0].PayYear
        "
        :anyAlertsExist="anyAlertsExist"
        :userDefinedFieldsExist="userDefinedFieldsExist"
        :flagAlertsExist="flagAlertsExist"
        :county="county"
        :currentPayYear="parcel.systemParameters[0].PayYear.toString()"
        :infoBannerText="infoBannerText"
        :item="parcel.propertyInfo"
        :udt1="parcel.systemParameters[0].USERDEFINEDTABLE1DESC"
        :udf1="parcel.systemParameters[0].USERDEFINEDFIELD1DESC"
        :udf2="parcel.systemParameters[0].USERDEFINEDFIELD2DESC"
      />
      <main id="parcel" class="container p-3">
        <section v-if="error">
          <search-error :county="county" :error="error" />
        </section>
        <section v-if="!error && !loading">
          <SkeletonAIMPContainer
            v-if="!parcel.propertyInfo"
            :lteInstalled="county.lteInstalled ? true : false"
            :photoUrlPrefix="county.photoUrlPrefix"
            :showMap="showMap"
          />

          <address-image-map-pay
            v-if="
              parcel.propertyInfo &&
                parcel.systemParameters &&
                parcel.systemParameters[0].PayYear &&
                parcel.billingSummary
            "
            :county="county"
            :currentPayYear="parseInt(parcel.systemParameters[0].PayYear)"
            :item="parcel.propertyInfo"
            :billingSummary="parcel.billingSummary"
            :isFuture="isFuture"
            :class="isMobile"
            :showMap="showMap"
            :isMobile="isMobile"
          />
        </section>

        <section v-if="!error && !loading" id="info">
          <property-info :county="county" :item="parcel.propertyInfo" />
        </section>

        <section
          v-if="!error && !loading && parcel.billingSummary && !isFuture"
          id="billing"
        >
          <h2 class="mt-3 pb-1 border-bottom">Billing</h2>
          <h3 v-if="parcel.billingDetail" class="h4">Detail</h3>
          <billing-detail
            v-if="parcel.billingDetail"
            :items="parcel.billingDetail"
          />

          <h3 class="h4">Payments</h3>
          <payment-history :items="parcel.paymentHistory" />

          <h3 class="h4">Tax History</h3>
          <tax-history
            v-if="!isFuture"
            :items="parcel.taxHistory"
            :countySlug="county.slug"
          />
        </section>

        <section v-if="!error && !loading && !isFuture" id="tax-overview">
          <h2 class="mt-3 pb-1 border-bottom">Tax Overview</h2>

          <h3 class="h4">Current Tax Summary</h3>
          <tax-summary
            :item="parcel.taxSummary[0] || {}"
            :ltiDisplayRate="parcel.systemParameters[0].LTIDISPLAYRATE"
            :currentPayYear="parseInt(parcel.systemParameters[0].PayYear)"
          />

          <h3 class="h4">
            Assessed Values
            {{
              parcel.assessedValues[0].Detail.AssessmentDate ? " as of " : ""
            }}
            {{ parcel.assessedValues[0].Detail.AssessmentDate | toDate }}
          </h3>
          <assessed-values :county="county" :items="parcel.assessedValues" />

          <h3 v-if="parcel.exemptionsDeductions" class="h4">
            Exemptions / Deductions
          </h3>
          <exemptions-deductions
            v-if="parcel.exemptionsDeductions && county"
            :items="parcel.exemptionsDeductions"
            :corpCode="county.corpCode"
            :lteInstalled="county.lteInstalled ? true : false"
            :taxType="parcel.propertyInfo.TaxType"
            :adjustments="parcel.adjustments"
            :parcelStatus="parcel.propertyInfo.Status"
          />

          <h3 v-if="parcel.otherAssessments" class="h4">Other Assessments</h3>
          <other-assessments
            v-if="parcel.otherAssessments"
            :items="parcel.otherAssessments"
          />

          <h3 v-if="parcel.projects && parcel.projects.length" class="h4">
            Property Projects &nbsp;<span class="fs-6 fw-light"
              >* Billed separately from the Property Tax Bill</span
            >
          </h3>
          <property-projects
            v-if="parcel.projects && parcel.projects.length"
            :projects="parcel.projects"
            :corpCode="this.county.corpCode.toUpperCase()"
          />
        </section>

        <section v-if="!error && !loading" id="history">
          <h2 class="mt-3 pb-1 border-bottom">History</h2>

          <contract :item="parcel.propertyInfo" />

          <bankruptcy :item="parcel.propertyInfo" />

          <h3 v-if="parcel.propertyHistory" class="h4">Property</h3>
          <property-history
            v-if="parcel.propertyHistory"
            :items="parcel.propertyHistory"
            :countySlug="county.slug"
          />

          <h3 v-if="parcel.transferHistory" class="h4">Transfer</h3>
          <transfer-history
            v-if="parcel.transferHistory"
            :items="parcel.transferHistory"
          />
        </section>
      </main>
    </div>
    <county-footer :county="county" :last-updated="lastUpdated" />
  </div>
</template>

<style>
#parcel h3.h4 {
  font-size: 1.25rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
/* add left padding to all table columns except first */
table.table td + td {
  padding-left: 1rem;
}
table.table.ledger th + td {
  padding-left: 1rem;
}
.skeleton {
  background-color: gray;
}
.skeleton-map {
  min-height: 300px;
  max-height: 600px;
}
.skeleton-image {
  min-height: 200px;
  max-height: 400px;
}
.w-40 {
  width: 40%;
}
</style>

<style scoped>
.container {
  max-width: 1020px !important;
}
#home {
  padding: 30px 30px 15px;
  background-color: white;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
@media only screen and (max-width: 1020px) {
  #home {
    border-radius: 0;
    padding: 15px;
  }
}
</style>

<script>
import AddressImageMapPay from "../components/parcel/AddressImageMapPay";
import AssessedValues from "../components/parcel/AssessedValues";
import Bankruptcy from "../components/parcel/BankruptcyComponent";
import BillingDetail from "../components/parcel/BillingDetail";
import Contract from "../components/parcel/ContractComponent";
import CountyFooter from "../components/county/FooterComponent";
import ExemptionsDeductions from "../components/parcel/ExemptionsDeductions";
import OtherAssessments from "../components/parcel/OtherAssessments";
import PaymentHistory from "../components/parcel/PaymentHistory";
import PropertyHistory from "../components/parcel/PropertyHistory";
import PropertyInfo from "../components/parcel/PropertyInfo";
import SearchError from "../components/common/SearchError";
import TaxHistory from "../components/parcel/TaxHistory";
import TaxSummary from "../components/parcel/TaxSummary";
import Toolbar from "../components/parcel/ToolbarComponent";
import TransferHistory from "../components/parcel/TransferHistory";
import AlertsComponent from "../components/parcel/AlertsComponent.vue";
import CountyHeader from "../components/common/CountyHeader.vue";
import PropertyProjects from "../components/parcel/PropertyProjects.vue";
import SkeletonAIMPContainer from "@/components/parcel/SkeletonAIMPContainer.vue";

export default {
  components: {
    AddressImageMapPay,
    AssessedValues,
    Bankruptcy,
    BillingDetail,
    Contract,
    CountyFooter,
    CountyHeader,
    ExemptionsDeductions,
    OtherAssessments,
    PaymentHistory,
    PropertyHistory,
    PropertyInfo,
    SearchError,
    TaxHistory,
    TaxSummary,
    Toolbar,
    TransferHistory,
    AlertsComponent,
    PropertyProjects,
    SkeletonAIMPContainer,
  },
  data() {
    return {
      isMobile: screen.width <= 750 ? "mobile" : "desktop",
      error: null,
      lastUpdated: "",
      loading: false,
      parcel: {
        assessedValues: [
          {
            Detail: {
              AssessmentDate: "",
            },
          },
        ],
        propertyInfo: { BillingDuplicateNumber: -1 },
        systemParameters: [
          {
            LTIDISPLAYRATE: "",
            LTISHOWCOUNTYINFORMATIONBANNER: null,
            LTICOUNTYINFORMATIONBANNER: null,
            USERDEFINEDTABLE1DESC: null,
            USERDEFINEDFIELD1DESC: null,
            USERDEFINEDFIELD2DESC: null,
          },
        ],
        taxHistory: [
          {
            PayYear: new Date().getFullYear(),
          },
        ],
        taxSummary: [{}],
      },
    };
  },
  computed: {
    lteURL() {
      let url = process.env.VUE_APP_LTE;
      if (!url) {
        return;
      }
      url = url.replace("{{CorpCode}}", this.county.corpCode);
      url = url.replace("{{Dup}}", this.$route.params.dup);

      if (this.isFuture) {
        url = url + "&payyear=" + parseInt(this.$route.params.payYear);
      }

      return url;
    },
    infoBannerText() {
      return (this.parcel.systemParameters[0].LTISHOWCOUNTYINFORMATIONBANNER ==
        "Y" ||
        this.parcel.systemParameters[0].LTISHOWCOUNTYINFORMATIONBANNER ==
          "T") &&
        this.parcel.systemParameters[0].LTICOUNTYINFORMATIONBANNER &&
        this.parcel.systemParameters[0].LTICOUNTYINFORMATIONBANNER.length > 0
        ? this.parcel.systemParameters[0].LTICOUNTYINFORMATIONBANNER
        : null;
    },
    userDefinedFieldsExist() {
      return Boolean(
        this.parcel.propertyInfo.UserDefinedField1 ||
          this.parcel.propertyInfo.UserDefinedField2
      );
    },

    flagAlertsExist() {
      return Boolean(
        // uncomment here and in AlertsComponent.vue to show Inactive Banner
        // this.parcel.propertyInfo.Status === "I" ||
        this.getBool(this.parcel.propertyInfo.Bankruptcy) ||
          this.getBool(this.parcel.propertyInfo.CertifiedToCourt) ||
          this.parcel.propertyInfo.ContractBuyerOfRecord ||
          this.getBool(this.parcel.propertyInfo.DemandNotice) ||
          this.parcel.propertyInfo.FutureChangedMailingAddress ||
          this.getBool(this.parcel.propertyInfo.GovernmentProperty) ||
          this.getBool(this.parcel.propertyInfo.HomesteadCreditAlert) ||
          this.getBool(this.parcel.propertyInfo.SubjectToCertificateSale) ||
          this.getBool(this.parcel.propertyInfo.SubjectToDeedSale) ||
          this.getBool(this.parcel.propertyInfo.SubjectToSheriffSale) ||
          this.getBool(this.parcel.propertyInfo.SubjectToTaxSale) ||
          this.getBool(this.parcel.propertyInfo.TaxSaleSold) ||
          this.parcel.propertyInfo.Transferred
      );
    },
    anyAlertsExist() {
      return (
        Boolean(this.infoBannerText) ||
        this.userDefinedFieldsExist ||
        this.flagAlertsExist
      );
    },
    showMap() {
      if (this.county.mapping && this.county.mapping.arcgis) {
        return (
          typeof this.county.mapping.arcgis === "object" &&
          this.county.mapping.arcgis !== null &&
          this.county.mapping.arcgis.rest_api_url.length > 0
        );
      } else {
        return false;
      }
    },
  },
  methods: {
    getBool(value) {
      const t = typeof value;
      if (t === "string") {
        return value === "T";
      } else if (t === "boolean") {
        return value;
      } else {
        return false;
      }
    },
    loadApiData(data) {
      try {
        this.loading = true;
        this.parcel = data || {};
        this.lastUpdated = data.systemParameters[0].LTI_LastImportDate || "";
        window.sessionStorage.setItem(
          "parcel-params",
          JSON.stringify(this.$route.params)
        );

        window.sessionStorage.setItem("parcel", JSON.stringify(data));
        if (data.propertyInfo && data.propertyInfo.RestrictAddress) {
          alert(
            "This Parcel is restricted per IC 36-1-8.5.\r\nFor additional information please contact the County Auditor's Office."
          );
        }
      } finally {
        this.loading = false;
        if (this.$route.hash) {
          this.scrollToAnchor(this.$route.hash);
        }
      }
    },
    mapCachedParcel(obj) {
      this.parcel.propertyInfo = {};
      this.parcel.propertyInfo.BillingDuplicateNumber =
        obj.BillingDuplicateNumber;
      this.parcel.propertyInfo.MAILINGADDRESS1 = obj.MailingAddress1;
      this.parcel.propertyInfo.MAILINGADDRESS2 = obj.MailingAddress2;
      this.parcel.propertyInfo.MAILINGCITY = obj.MailingCity;
      this.parcel.propertyInfo.MAILINGSTATE = obj.MailingState;
      this.parcel.propertyInfo.MAILINGZIPCODE = obj.MailingZipCode;
      this.parcel.propertyInfo.MortgageCompanyLastChangedDate = "999999";
      this.parcel.propertyInfo.OwnerName = obj.OwnerOfRecord;
      this.parcel.propertyInfo.PAYYEAR = new Date().getFullYear();
      this.parcel.propertyInfo.Photo = obj.Photo;
      this.parcel.propertyInfo.PROPERTYADDRESS1 = obj.PropertyAddress1;
      this.parcel.propertyInfo.PROPERTYCITY = obj.PropertyCity;
      this.parcel.propertyInfo.PROPERTYSTATE = obj.PropertyState;
      this.parcel.propertyInfo.PROPERTYZIPCODE = obj.PropertyZipCode;
      this.parcel.propertyInfo.StateKey = obj.StateKey;
      this.parcel.propertyInfo.TaxType = obj.TaxType;
      this.parcel.propertyInfo.UNFORMATEDSTATEKEY = obj.UnformattedStateKey;
    },
    scrollToAnchor(hash) {
      setTimeout(() => {
        if (["", "#", "#home", "#top"].indexOf(hash) >= 0) {
          return;
        } else {
          this.$scrollTo(hash);
        }
      }, 100);
    },
    search(dup, payYear) {
      // cancel if no search parameters exist
      if (!String(dup).length || !payYear) {
        return {};
      }

      this.axios
        .get(process.env.VUE_APP_DATASERVICE + "GetParcel", {
          params: {
            CorpCode: this.county.corpCode.toUpperCase(),
            dup: dup,
            PayYear: parseInt(payYear),
          },
        })
        .then((response) => {
          this.error = null;
          this.loadApiData(response.data);
        })
        .catch((error) => {
          this.error = error;
          this.loading = false;
        });
    },
  },
  props: {
    county: {
      type: Object,
      required: true,
    },
    isFuture: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  beforeCreate() {
    if (!this.$route.hash || this.$route.hash === "") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  },
  watch: {
    "$route.params": {
      handler: function(params) {
        const cachedResults =
          JSON.parse(sessionStorage.getItem("search-results")) || {};
        if (cachedResults.Results) {
          const cachedParcel =
            cachedResults.Results.find(
              (item) =>
                !this.isFuture && item.BillingDuplicateNumber === params.dup
            ) || null;
          // temporarily map cachedParcel data to parcel (faster, better UX)
          if (cachedParcel) {
            this.mapCachedParcel(cachedParcel);
            this.loading = false;
          }
        }
        if (
          !this.$route.hash ||
          this.parcel.propertyInfo.BillingDuplicateNumber === -1
        ) {
          // search for parcel data (guess PayYear if not part of URL - if wrong, will redirect using actual latest PayYear from SystemParameters!)
          this.search(
            params.dup,
            parseInt(params.payYear) || this.parcel.taxHistory[0].PayYear
          );
        }
      },
      immediate: true,
      deep: false,
    },
  },
};
</script>
